<template>
  <div>
    <h3 class="mb-5">Project Showcase</h3>
    <div class="h4 mb-5">ESG內頁</div>

    <!-- Items -->
    <div>
      <div
        class="form-item d-flex py-3 align-center"
        v-for="(item, i) in csr.projects"
        :key="i"
      >
        <div
          class="w-40px h-40px bg-cover bg-center bg-c"
          :style="{
            'background-image': `url(${item.image})`,
          }"
        ></div>
        <div class="h4 ml-5">{{ item.title }}</div>
        <div class="ml-auto">
          <button class="btn square ml-10px" @click="editItem(item)">
            <v-icon>edit</v-icon>
          </button>
          <button class="btn square ml-10px" @click="deleteItem(item)">
            <v-icon>delete</v-icon>
          </button>
          <button class="btn square ml-10px" @click="downItem(item, i)">
            <v-icon>arrow_downward</v-icon>
          </button>
          <button class="btn square ml-10px" @click="upItem(item, i)">
            <v-icon>arrow_upward</v-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- add item -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem()">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加 ESG Project</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    csr: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    itemList: [
      {
        id: '001',
        imageUrl:
          'https://images.unsplash.com/photo-1560698711-6df2370d7d62?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
        title: 'CSR Project Name',
      },
      {
        id: '002',
        imageUrl: '',
        title: 'CSR Project Name1',
      },
      {
        id: '003',
        imageUrl: '',
        title: 'CSR Project Name2',
      },
      {
        id: '004',
        imageUrl: '',
        title: 'CSR Project Name3',
      },
      {
        id: '005',
        imageUrl: '',
        title: 'CSR Project Name4',
      },
    ],
  }),
  methods: {
    ...mapActions({
      initProjectDetail: 'csr/initProjectDetail',
    }),
    addItem() {
      const detail = {
        title: '',
        image: '',
        description: '',
        content: [],
        downloads: [],
      };
      this.initProjectDetail(detail);
      this.$router.push({
        path: '/csr-page/edit/project-show-case',
      });
    },
    editItem(item) {
      this.initProjectDetail(item);
      this.$router.push({ path: '/csr-page/edit/project-show-case' });
    },
    deleteItem(item) {
      const index = this.csr.projects.map((option) => option.id).indexOf(item.id);
      this.csr.projects.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.csr.projects.length - 1) {
        this.csr.projects.splice(i, 1);
        this.csr.projects.unshift(item);
        return;
      }
      // item become next index
      this.csr.projects.splice(i, 1);
      this.csr.projects.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.csr.projects.splice(i, 1);
        this.csr.projects.push(item);
        return;
      }
      // item become previous index
      this.csr.projects.splice(i, 1);
      this.csr.projects.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
